import React from 'react';
import {Skeleton} from 'antd';
import styled from 'styled-components';
import {mediaScreenSizes} from '../../../utils/constans/styles/screenSizes';

const SkeletonCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SkeletonCardMainContent = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 10px 10px 0 0;
  border: 1px solid #D9D9D9;
  background: #FAFAFA;
  border-bottom: none;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    flex-direction: column;
  }
`;

const SkeletonImageWrapper = styled.div`
  width: 200px;
  min-width: 200px;
  height: 100%;
  min-height: 150px;
  border-radius: 10px 0 0 0;
  overflow: hidden;
  background: #F0F0F0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    width: 92px;
    height: 72px;
    border-radius: 7px;
    margin: 0 16px 16px 16px;
    align-self: flex-start;
    min-height: 72px;
  }
`;

const SkeletonInfoWrapper = styled.div`
  padding: 16px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  flex-grow: 1;
`;

const SkeletonHeader = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  justify-content: space-between;
  align-items: flex-start;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    flex-direction: column;
    row-gap: 8px;
  }
`;

const SkeletonTitleAndDate = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-grow: 1;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    justify-content: flex-end;
    flex-direction: column-reverse;
    row-gap: 8px;
  }
`;

const SkeletonTitle = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 18px;
  align-items: center;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const SkeletonDateAndDelete = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
`;

const SkeletonDetailsAndAction = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    flex-direction: column;
    row-gap: 16px;
    align-items: flex-start;
  }
`;

const SkeletonDetails = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 32px;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    flex-direction: column;
    row-gap: 8px;
  }
`;

const SkeletonDetailsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SkeletonNoOffersSection = styled.div`
  border-top: 1px solid #D9D9D9;
  padding: 16px;
  background: #FAFAFA;
  border-radius: 0 0 10px 10px;
`;

export const EmptyLegCardSkeleton: React.FC = () => {
  return (
    <SkeletonCardWrapper>
      <SkeletonCardMainContent>
        <SkeletonImageWrapper>
          <Skeleton.Image style={{ width: '100%', height: '100%' }} />
        </SkeletonImageWrapper>
        <SkeletonInfoWrapper>
          <SkeletonHeader>
            <SkeletonTitleAndDate>
              <SkeletonTitle>
                <Skeleton.Input active size="small" style={{ width: 180, height: 22 }} />
                <Skeleton.Input active size="small" style={{ width: 60, height: 22 }} />
              </SkeletonTitle>
              <SkeletonDateAndDelete>
                <Skeleton.Input active size="small" style={{ width: 120, height: 14 }} />
                <Skeleton.Button active size="small" shape="circle" style={{ width: 22, height: 22, minWidth: 22 }} />
              </SkeletonDateAndDelete>
            </SkeletonTitleAndDate>
          </SkeletonHeader>
          <SkeletonDetailsAndAction>
            <SkeletonDetails>
              <SkeletonDetailsItem>
                <Skeleton.Input active size="small" style={{ width: 50, height: 22 }} />
                <Skeleton.Input active size="small" style={{ width: 150, height: 22 }} />
              </SkeletonDetailsItem>
              <SkeletonDetailsItem>
                <Skeleton.Input active size="small" style={{ width: 40, height: 22 }} />
                <Skeleton.Input active size="small" style={{ width: 200, height: 22 }} />
              </SkeletonDetailsItem>
              <SkeletonDetailsItem>
                <Skeleton.Input active size="small" style={{ width: 45, height: 22 }} />
                <Skeleton.Input active size="small" style={{ width: 100, height: 22 }} />
              </SkeletonDetailsItem>
            </SkeletonDetails>
            <Skeleton.Button active style={{ width: 100, height: 40 }} />
          </SkeletonDetailsAndAction>
        </SkeletonInfoWrapper>
      </SkeletonCardMainContent>
      <SkeletonNoOffersSection>
        <Skeleton.Input active size="small" style={{ width: 80, height: 20 }} />
      </SkeletonNoOffersSection>
    </SkeletonCardWrapper>
  );
};

